<script>
import BusinessList from '../businesses/BusinessList'

export default {
  name: 'user-business-list',
  extends: BusinessList,
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  async created () {
    this.showFilters = false
    this.filters.userId = this.id
    await this.getBusinesses()
  },
}
</script>
